import { useSyncExternalStore } from 'react'
import { BREAKPOINTS } from '../lib/constants'
import { layoutFor, type Layout } from '../lib/layout'

// Two layouts only (ux/02): phone below 900 px shops, everything wider plans.
// matchMedia rather than a resize listener, so it changes exactly at the
// breakpoint layoutFor() names.
const QUERY = `(min-width: ${BREAKPOINTS.desktop}px)`

function subscribe(onChange: () => void) {
  if (typeof window === 'undefined' || !window.matchMedia) return () => {}
  const mq = window.matchMedia(QUERY)
  mq.addEventListener('change', onChange)
  return () => mq.removeEventListener('change', onChange)
}

function snapshot(): Layout {
  if (typeof window === 'undefined') return 'phone'
  if (window.matchMedia) return window.matchMedia(QUERY).matches ? 'desktop' : 'phone'
  return layoutFor(window.innerWidth)
}

export function useLayout(): Layout {
  return useSyncExternalStore(subscribe, snapshot, () => 'phone')
}
